import { render } from "./UserProfile.vue?vue&type=template&id=0a8999ef&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=0a8999ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8999ef"]])

export default __exports__